/**
 * LEGACY: single remaining fetcher for the pre-refresh Knowledge Database —
 * historical comment citation chips still look records up by id. The route
 * is retired server-side, so this 404s and the chips render their
 * "Source was deleted from the Knowledge Database" fallback. Everything else
 * moved to services/knowledge.ts with the knowledge refresh.
 */
import { API_URL } from "../config/env";
import { smartFetch } from "../utils/http";
import { parseResponse } from "../utils/parseResponse";
import { getKnowledgeDataRecordResponseSchema } from "../utils/parsers/knowledge-db";

export async function getKnowledgeDataRecord(knowledgeDataRecordId: string) {
  const json = await smartFetch(
    `${API_URL}/private/catalyst/knowledgeDataRecord/${encodeURIComponent(knowledgeDataRecordId)}`,
    {
      method: "GET",
    },
  );

  const parsedData = parseResponse(getKnowledgeDataRecordResponseSchema, json);

  return parsedData;
}
